<template>
  <v-dialog width="800px" persistent v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn outlined v-on="on" class="mx-2">
      <v-icon left>mdi-plus</v-icon>
      Create Event
      </v-btn>
    </template>
      <v-card>
        <v-card-title>Create a Calendar Event
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = !dialog"><v-icon>mdi-arrow-left</v-icon></v-btn>
        </v-card-title>
      </v-card>
      <v-card>
        <v-container>
          <v-form @submit.prevent="onCreateCalendarEvent">
            <v-flex xs8 offset-xs2>
              <v-text-field
                label="Enter Event Name"
                id="name"
                name="name"
                v-model="name"
                prepend-icon="mdi-bulletin-board"
                :rules="rule1"
              >
              </v-text-field>
              <v-text-field
                label="Enter Location"
                id="location"
                name="location"
                v-model="location"
                prepend-icon="mdi-beach"
                :rules="rule1"
              >
              </v-text-field>
              <v-select
                :items="items"
                label="Color"
                name="color"
                id="color"
                v-model="color"
                prepend-icon="mdi-format-color-fill"
                :rules="rule1"
              >
              </v-select>
              <v-date-picker
                range
                id="date"
                name="date"
                v-model="date"
              >
              </v-date-picker>
              <h4 v-if="date[0]!==undefined">Starting Date: {{date[0]}}</h4>
              <h4 v-if="date[1]!==undefined">End Date: {{date[1]}}</h4>
              <v-text-field
                v-model="dateRangeText"
                label="Date range"
                prepend-icon="mdi-calendar"
                readonly
              ></v-text-field>
              <v-time-picker
                id="starttime"
                name="starttime"
                v-model="starttime"
                format="24hr"
              >
              </v-time-picker>
              <v-time-picker
                class="ml-2"
                id="endtime"
                name="endtime"
                v-model="endtime"
                format="24hr"
              >
              </v-time-picker>
              <h4 v-if="starttime!==null">Starting Time: {{starttime}}</h4>
              <h4 v-if="endtime!==null">End Time: {{endtime}}</h4>
              <v-text-field
                label="Enter Participants"
                id="participants"
                name="participants"
                v-model="participants"
                prepend-icon="mdi-account-multiple"
                :rules="rule2"
              >
              </v-text-field>
              <v-textarea
                label="Enter Notes"
                id="notes"
                v-model="notes"
                prepend-icon="mdi-note-text"
              >
              </v-textarea>
            </v-flex>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="mx-2 red" @click="dialog = !dialog">
                <v-icon left>mdi-close</v-icon>
                Close
              </v-btn>
              <v-btn
                :disabled="!formIsValid"
                class="ma-2"
                color="green"
                @click="onCreateCalendarEvent"
              >
                <v-icon left>mdi-plus</v-icon>
                Add Event
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-container>
      </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      name: '',
      location: '',
      participants: '',
      color: '',
      notes: '',
      date: [],
      starttime: '',
      endtime: '',
      timestamp: '',
      items: ['red', 'yellow', 'blue', 'green', 'grey', 'white', 'black', 'pink', 'purple', 'orange'],
      rule1: [
        value => !!value || 'Required',
        value => (value || '').length <= 40 || 'Max 40 characters'
      ],
      rule2: [
        value => !!value || 'Required',
        value => (value || '').length <= 100 || 'Max 100 characters'
      ]
    }
  },
  methods: {
    onCreateCalendarEvent () {
      if (!this.formIsValid) {
        return
      }
      this.startdate = this.date[0]
      this.enddate = this.date[1]
      this.timestamp1 = this.startdate + ' ' + this.starttime
      this.timestamp2 = this.enddate + ' ' + this.endtime
      const eventData = {
        name: this.name,
        location: this.location,
        participants: this.participants,
        notes: this.notes,
        date: this.date,
        timestamp1: this.timestamp1,
        timestamp2: this.timestamp2,
        color: this.color,
        startdate: this.startdate,
        enddate: this.enddate,
        starttime: this.starttime,
        endtime: this.endtime
      }
      this.$store.dispatch('createCalendarEvent', eventData)
      this.dialog = false
    }
  },
  computed: {
    formIsValid () {
      if (this.date[0] !== this.date[1]) {
        return this.name !== '' && this.location !== '' && this.date !== [] && this.starttime !== null && this.endtime !== null && this.participants !== ''
      } else {
        return this.name !== '' && this.location !== '' && this.date !== [] && this.starttime > this.endtime && this.participants !== ''
      }
    },
    dateRangeText () {
      if (this.date[0] === this.date[1]) {
        return this.date[0]
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.date.sort()
        return this.date.join(' - ')
      }
    }
  }
}
</script>

<style>

</style>
